import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "./CreateTaskModal.css";
import { PRIORITY_FILTERS, STATUS_FILTERS } from "../../../../utils/taskUtils";
import { useDispatch, useSelector } from "react-redux";
import { getAllOfficers, getAllTaskPriorities, getAllTaskStatuses, getAllTaskTypes } from "../../../../redux/TaskReducer/action";
import { toast } from "react-toastify";
import axios from "axios";

function CreateTaskModal1({ showModal, onNext, onClose }) {

  const { taskStatuses, taskPriorities, officers, applicationId, taskTypes } = useSelector((store) => {
      return {
          taskStatuses: store.TasksReducer.taskStatuses,
          taskPriorities: store.TasksReducer.taskPriorities,
          officers: store.TasksReducer.officers,
          applicationId: store.ApplicationReducer.currentApplicationId,
          taskTypes: store.TasksReducer.taskTypes
      }
  });

  const [newTask, setNewTask] = useState({
    application_id: "",
    // assigned_to: "",
    title: "",
    description: "",
    category_id: "",
    // current_status_id: "",
    priority_id: "",
    due_date: "",
    // user_details: null
  })

  const [statusFilters, setStatusFilters] = useState(STATUS_FILTERS);
  const [priorityFilters, setPriorityFilters] = useState(PRIORITY_FILTERS);

  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(getAllTaskPriorities(priorityFilters));
    dispatch(getAllTaskStatuses(statusFilters));
    dispatch(getAllOfficers(1, 20000));
  }, [priorityFilters, statusFilters]);

  useEffect(() => {
    setNewTask(prev => ({
      ...prev,
      application_id: applicationId,
    }));
  }, [applicationId]);

  useEffect(() => {
     dispatch(getAllTaskTypes({
        is_active: true
    }));
  }, []);

  const handleChange = (e) => {
    let { name, value } = e.target;

    setNewTask((prev) => ({
      ...prev,
      [name]: name === "current_status_id" || name === "priority_id" || name === "category_id"  ? Number(value): value
    }))
  }

  const createTask = async (newTask) => {
      console.log({ newTask });

      let tokens = JSON.parse(sessionStorage.getItem("tokens")) || JSON.parse(localStorage.getItem("tokens")) || null;
      let authToken = tokens?.token || null;

      if (!authToken) {
        toast.error(`Invalid or missing token.`)
        return;
      }

      let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
      }

      try {
        let response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/task/create`, newTask, { headers });

        if(response?.data){
          toast.success(`${response?.data?.message}`);
          let taskID = response?.data?.data?.task_id;
          onNext(taskID, newTask?.category_id);
        }
      }
      catch (error) {
        let errResponse = error?.response?.data;
        toast.error(`${errResponse?.message}`);
      }
  }

  return (
    <Modal show={showModal} onHide={onClose} backdrop="static" size="lg" dialogClassName="create-task-modal" className="create-task-modal-1">
      <Modal.Header closeButton>
        <Modal.Title>Create New Task</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label name="application_id">Case ID</Form.Label>
            <Form.Control 
              type="text"
              name="application_id"
              value={newTask.application_id}
              placeholder="Application ID"
              onChange={handleChange}
              // disabled 
            />
          </Form.Group>

          {/* <Form.Group className="mb-3">
            <Form.Label name="assigned_to">Assigned To*</Form.Label>
            <Form.Select
              name="assigned_to"
              value={newTask.assigned_to || ""}
              onChange={handleChange}
              style={{
                color: !newTask.assigned_to ? "var(--border-color)" : ""
              }}
            >
              <option value={""}>Select Officer</option>
              {
                officers?.map((officer) => (
                    <option
                      key={officer?.officer_id}
                      value={officer?.officer_id}
                    >
                     {`${officer?.first_name}${officer?.last_name ? ` ${officer?.last_name}` : ""}`} {officer?.emp_id}
                    </option>
                ))
              }
            </Form.Select>
          </Form.Group> */}

          {/* <Form.Group className="mb-3">
            <Form.Label name="assigned_to">Assigned To*</Form.Label>
            <Form.Select
              name="assigned_to"
              value={newTask.assigned_to || ""}
              onChange={handleChange}
              style={{
                color: !newTask.assigned_to ? "var(--border-color)" : ""
              }}
            >
              <option value={""}>Select Officer</option>
              <option value="RO">RO</option>
              <option value="BM">BM</option>
              <option value="BCM">BCM</option>
            </Form.Select>
          </Form.Group> */}

          {/* <Form.Group className="mb-3">
            <Form.Label name="current_status_id">Current Status*</Form.Label>
            <Form.Select
              name="current_status_id"
              value={newTask.current_status_id || ""}
              onChange={handleChange}
              style={{
                color: !newTask.current_status_id ? "var(--border-color)" : ""
              }}
            >
              <option value={""}>Select Status</option>
              {
                taskStatuses?.map((status) => (
                    <option
                      key={status.status_id}
                      value={status.status_id}
                    >
                      {status.status_name}
                    </option>
                ))
              }
            </Form.Select>
          </Form.Group> */}

          <Form.Group className="mb-3">
            <Form.Label name="category_id">Category*</Form.Label>
            <Form.Select
              name="category_id"
              value={newTask.category_id || ""}
              onChange={handleChange}
              style={{
                color: !newTask.category_id ? "var(--border-color)" : ""
              }}
            >
               <option value={""}>Select Category</option>
              {
                taskTypes?.map((type) => (
                    <option
                      key={type.type_id}
                      value={type.type_id}
                    >
                      {type.type_name}
                    </option>
                ))
            }
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label name="priority_id">Priority*</Form.Label>
            <Form.Select
              name="priority_id"
              value={newTask.priority_id || ""}
              onChange={handleChange}
              style={{
                color: !newTask.priority_id ? "var(--border-color)" : ""
              }}
            >
               <option value={""}>Select Priority</option>
              {
                taskPriorities?.map((priority) => (
                    <option
                      key={priority.priority_id}
                      value={priority.priority_id}
                    >
                      {priority.priority_name}
                    </option>
                ))
            }
            </Form.Select>
          </Form.Group>

          {/* <Form.Group className="mb-3">
            <Form.Label name="title">Title*</Form.Label>
            <Form.Control 
              type="text" 
              name="title"
              value={newTask.title}
              placeholder="Title" 
              onChange={handleChange}
            />
          </Form.Group> */}

          {/* <Form.Group className="mb-3">
            <Form.Label name="description">Description*</Form.Label>
            <Form.Control 
              type="text" 
              name="description"
              value={newTask.description}
              placeholder="Description" 
              onChange={handleChange}
            />
          </Form.Group> */}

          <Form.Group className="mb-3">
            <Form.Label name="due_date">Target Completion Date*</Form.Label>
            <Form.Control 
              type="date" 
              name="due_date"
              value={newTask.due_date}
              onChange={handleChange}
              style={{
                color: !newTask.due_date ? "var(--border-color)" : ""
              }}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button 
            variant="outline-secondary" 
            onClick={onClose}
            className="action-btn secondary-task-btn"
        >
            Cancel
        </Button>
        <Button 
            className="action-btn next-btn" 
            // onClick={onNext}
            onClick={() => {
              createTask(newTask);
            }}
        >
            Next
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateTaskModal1;
